import React from 'react';
import { Reveal } from './Reveal';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section aria-labelledby="kit-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-136" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-content" data-id="element-137" data-mp="257hat8mlqdnr">
        <div className="mb-12 text-center" data-id="element-138" data-mp="2a7c1bb2gt18a">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-139" data-mp="2a84yplfjaedr">
            TUTTO IN UN UNICO PACK
          </p>
          <h2 id="kit-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-140" data-mp="2f4lun1sz5x1e">
            📘 Cosa Contiene EDUCAZIONE FISICA PRONTA™?
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-141" data-mp="2o1313rqe96qt">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-[18px] border border-brand-sand bg-brand-cream p-7 text-center" data-id="element-142" data-mp="2xxg0954pkcsy">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-primary" strokeWidth={1.5} aria-hidden="true" data-id="element-143" data-mp="10lm8t2hgwtiz" />
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-primary" data-id="element-144" data-mp="vmstr5mj8ugp">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-145" data-mp="qn6fqtyvra6u">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}